module.exports = __webpack_public_path__ + "media/images/illustrations/united-kingdom-27a46ac19bdb034c951fc0e64880e5e2.svg";